import React, { useState } from 'react';
import { Rocket, Home, Crown } from 'lucide-react';
import crypto from '../images/LargeBlack.svg';
import { motion } from 'framer-motion';

const Hero = () => {
  const [showProxyChoice, setShowProxyChoice] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleExtendProxy = () => {
    window.location.href = 'https://nexaproxy.com/extend';
  };

  const handleScanFingerprint = () => {
    window.location.href = 'https://scan.nexaproxy.com/';
  };
    const handleRdpVps = () => {
    window.location.href = 'https://rdp.nexaproxy.com/';
  };

  const handleSetupGuide = () => {
    window.open('https://medium.com/@geekombe/how-to-set-up-a-proxy-on-gologin-de47a82b9145', '_blank');
  };

  const proxyTypes = [
    {
      name: 'DataCenter',
      description: 'High-speed, reliable datacenter proxies',
      icon: Rocket,
      url: 'https://datacenter.nexaproxy.com/'
    },
    {
      name: 'Residential',
      description: 'Real residential IP addresses',
      icon: Home,
      url: 'https://residential.nexaproxy.com'
    },
    {
      name: 'Elite Proxies',
      description: 'Premium proxies for advanced needs',
      icon: Crown,
      url: 'https://elite.nexaproxy.com'
    }
  ];

  const handleProxySelect = (type) => {
    setIsRedirecting(true);
    setSelectedType(type);
    
    setTimeout(() => {
      window.location.href = type.url;
    }, 500);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 px-4 md:pt-28" id="home">
      {/* Background Gradient Effect */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-1/2 h-1/2 bg-accent/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-1/2 h-1/2 bg-purple-500/5 rounded-full blur-[120px]" />
      </div>

      
      <div className="container mx-auto max-w-5xl relative z-10">
        <div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            Gateway To The{' '}
            <span className="text-accent">Internet</span>
          </h1>
          <p className="text-text-secondary text-lg md:text-xl lg:text-2xl mb-12 max-w-2xl mx-auto leading-relaxed">
            Advanced Quality & Premium Proxies. 
            <br />
            Secure, Fast, and Reliable.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 flex-wrap">
            
            {/* Buy Proxy Button Action */}
            <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setShowProxyChoice(true)}
              className="w-full sm:w-auto bg-accent hover:bg-accent-hover text-dark-bg px-8 py-3.5 rounded-xl font-semibold text-base transition-colors cursor-pointer shadow-lg shadow-accent/20"
            >
              Buy Proxy 
            </button>

            {/* <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.location.href = 'https://datacenter.nexaproxy.com/'}
              className="w-full sm:w-auto bg-accent hover:bg-accent-hover text-dark-bg px-8 py-3.5 rounded-xl font-semibold text-base transition-colors cursor-pointer shadow-lg shadow-accent/20"
            >
              Buy Proxy 
            </motion.button> */}
            
            {/* <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleExtendProxy}
              className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-8 py-3.5 rounded-full font-semibold text-base transition-colors cursor-pointer shadow-lg shadow-purple-600/20"
            >
              ⏱️ Extend Proxy
            </button> */}

            {/* <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleScanFingerprint}
              className="w-full sm:w-auto bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white px-8 py-3.5 rounded-xl font-semibold text-base transition-all cursor-pointer shadow-lg shadow-cyan-600/20"
            >
              Scan Fingerprint
            </button> */}
            
            {/* <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={scrollToPricing}
              className="w-full sm:w-auto border-2 border-accent text-accent hover:bg-accent/10 px-8 py-3.5 rounded-full font-semibold text-base transition-colors cursor-pointer"
            >
              📋 View Plans
            </button> */}

            <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleSetupGuide}
              className="w-full sm:w-auto border-2 border-accent text-accent hover:bg-accent/10 px-8 py-3.5 rounded-xl font-semibold text-base transition-colors cursor-pointer"
            >
              Setup Guide
            </button>
                        <button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleRdpVps}
              className="w-full sm:w-auto bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white px-8 py-3.5 rounded-xl font-semibold text-base transition-all cursor-pointer shadow-lg shadow-cyan-600/20"
            >
              Buy RDP / VPS
            </button>
          </div>

          {/* Special Offer Banner - Moved below CTAs */}
          <div className="mb-8 mx-auto max-w-xl">
            <div className="bg-gradient-to-r from-accent/20 via-purple-500/20 to-accent/20 rounded-xl p-4 border border-accent/30 backdrop-blur-sm">
              <div className="flex items-center justify-center mb-1">

                <h3 className="text-base md:text-lg font-bold text-accent">Limited Time Offer!</h3>
              </div>
              <p className="text-sm md:text-base text-white">
                Buy 2 Residential Proxies, Get 1 at <span className="font-bold text-accent">$6</span> and Save <span className="font-bold text-accent">$2</span>
              </p>
            </div>
          </div>

          {/* Customer Stats Section */}
          {/* <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-gradient-to-br from-accent/20 via-purple-500/20 to-accent/20 backdrop-blur-sm rounded-xl p-6 transition-all shadow-xl shadow-accent/30 hover:shadow-2xl hover:shadow-accent/40">
              <div className="text-4xl font-bold text-accent mb-2">1000+</div>
              <div className="text-white text-base font-medium">Happy Customers</div>
            </div>
            
            <div className="bg-gradient-to-br from-purple-500/20 via-accent/20 to-purple-500/20 backdrop-blur-sm rounded-xl p-6 transition-all shadow-xl shadow-purple-500/30 hover:shadow-2xl hover:shadow-purple-500/40">
              <div className="text-4xl font-bold text-accent mb-2">5000+</div>
              <div className="text-white text-base font-medium">Orders Completed</div>
            </div>
            
            <div className="bg-gradient-to-br from-accent/20 via-purple-500/20 to-accent/20 backdrop-blur-sm rounded-xl p-6 transition-all shadow-xl shadow-accent/30 hover:shadow-2xl hover:shadow-accent/40">
              <div className="text-4xl font-bold text-accent mb-2">99.9%</div>
              <div className="text-white text-base font-medium">Uptime Guarantee</div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Proxy Choice Modal */}

        {showProxyChoice && (
          <div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => !isRedirecting && setShowProxyChoice(false)}
          >
            <div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-dark-secondary rounded-2xl p-8 md:p-10 max-w-lg w-full"
              onClick={e => e.stopPropagation()}
            >
              <h2 className="text-3xl font-bold mb-8 text-center">
                Choose Your <span className="text-accent">Proxy Type</span>
              </h2>
              
              <div className="space-y-4">
                {proxyTypes.map((type, index) => {
                  const Icon = type.icon;
                  return (
                    <button
                      key={type.name}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      disabled={isRedirecting}
                      onClick={() => handleProxySelect(type)}
                      className={`w-full p-6 rounded-xl bg-dark-bg hover:bg-accent/10 border border-gray-700 
                        hover:border-accent transition-all duration-300 cursor-pointer
                        ${isRedirecting && selectedType?.name !== type.name ? 'opacity-50' : ''}
                        ${isRedirecting ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                      <div className="flex items-center space-x-4">
                        <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-accent/10 text-accent flex-shrink-0">
                          <Icon className="w-6 h-6" strokeWidth={2} />
                        </span>
                        <div className="text-left flex-grow">
                          <div className="text-xl font-semibold mb-1 flex items-center justify-between">
                            {type.name}
                            {isRedirecting && selectedType?.name === type.name && (
                              <span className="inline-block">
                                <svg 
                                  className="animate-spin h-5 w-5 text-accent" 
                                  xmlns="http://www.w3.org/2000/svg" 
                                  fill="none" 
                                  viewBox="0 0 24 24"
                                >
                                  <circle 
                                    className="opacity-25" 
                                    cx="12" 
                                    cy="12" 
                                    r="10" 
                                    stroke="currentColor" 
                                    strokeWidth="4"
                                  />
                                  <path 
                                    className="opacity-75" 
                                    fill="currentColor" 
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  />
                                </svg>
                              </span>
                            )}
                          </div>
                          <div className="text-base text-text-secondary">{type.description}</div>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>

              <button
                onClick={() => !isRedirecting && setShowProxyChoice(false)}
                disabled={isRedirecting}
                className={`mt-8 w-full py-3 text-text-secondary hover:text-accent transition-colors text-lg
                  ${isRedirecting ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

    </section>
  );
};

export default Hero;